import React from 'react'
import { Outlet } from 'react-router-dom'
import WalletPaymentStatus from './Contents/RechargeUser/WalletPaymentStatus'

function Section() {
  return (
    <main className='section dashboard-content' id='dashboard-content' tabIndex={-1}>
    
    <WalletPaymentStatus />
    <Outlet/>
    
    </main>
  )
}

export default Section